<template lang="pug">
	.css-list-control
		input.css-list-title(ref="input" v-pseudo-modal-show="this._uid + 'css-list-control-dropdown'" :class="{'css-list-active-title': isModalActive}" :value="itemName" type="text" readonly)
		div.css-list-menu(v-pseudo-modal="this._uid + 'css-list-control-dropdown'")
			div(v-for="(item) in itemsInfo.items")
				.css-list-item(v-if="!isActiveItem(item.value, item.name)" @click="selectItem(item.value, item.name)" v-bind:title="item.description || ''") {{item.name}}

</template>

<script>

	import Screen 		from './../../../mixins/screen';

	import { Settings } from './../../../services/Settings';

	export default {
		name: "SettingCssList",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Version Switched", "Selected Version Fully Loaded"]
		},
		props: ['settingName', 'propertyName', 'startValue'],
		data() {

			this.cssListSettings = {
				'fontFamily': {
					items: [
						{name: 'initial', value: 'initial'},
						{name: 'inherit', value: 'inherit'}
						/* заполняются на основании ассетов */
					],
					default: 0
				},
				'fontWeight': {
					items: [
						{name: 'thin', value: '100'},
						{name: 'extra light', value: '200'},
						{name: 'light', value: '300'},
						{name: 'normal', value: '400', synonyms: ['normal']},
						{name: 'medium', value: '500'},
						{name: 'semi bold', value: '600'},
						{name: 'bold', value: '700', synonyms: ['bold']},
						{name: 'extra bold', value: '800'},
						{name: 'ultra bold', value: '900'},
						{name: 'initial', value: 'initial'},
						{name: 'inherit', value: 'inherit'}
					],
					default: 3
				},
				'fontStyle': {
					items: [
						{name: 'normal', value: 'normal'},
						{name: 'italic', value: 'italic'},
						{name: 'initial', value: 'initial'},
						{name: 'inherit', value: 'inherit'}
					],
					default: 0
				},
				'cursor': {
					items: [
						{name: 'auto', value: 'auto'},
						{name: 'pointer', value: 'pointer'},
						{name: 'initial', value: 'initial'},
						{name: 'inherit', value: 'inherit'}
					],
					default: 0
				},
				'textAlign': {
					items: [
						{name: 'left', value: 'left'},
						{name: 'right', value: 'right'},
						{name: 'center', value: 'center'},
						{name: 'justify', value: 'justify', description: 'Stretches the lines so that each line has equal width (like in newspapers and magazines)'},
						{name: 'initial', value: 'initial'},
						{name: 'inherit', value: 'inherit'}
					],
					default: 0
				}
			};

			this.standardFonts = ['Arial'];

			this.value = '';

			this.itemsInfo = {};

			return {
				showed: true,
				itemName: '',
				isModalActive: false
			};

		},
		created() {

			Broadcast.on(`Pseudo Modal Showed ${this._uid}css-list-control-dropdown`, () => {

				this.isModalActive = true;

				this.$refs.input.value = '';
				this.$refs.input.value = this.itemName;

			}, this);

			Broadcast.on(`Pseudo Modal Hided ${this._uid}css-list-control-dropdown`, () => {

				this.isModalActive = false;

				this.$refs.input.value = '';
				this.$refs.input.value = this.itemName;

			}, this);

		},
		mounted() {

			//Сообщаем компоненту что он должен обновляться при изменении текущей настройки активной версии креатива
			this.addUpdateEvent(`Selected Version Setting Changed:${this.settingName}`);

		},
		methods: {
			collectData(event_name) {

				if (!Version.SelectedVersion || !this.settingName) return;

				let values = Settings.getSettingValue(this.settingName) || {};

				this.value = values[this.propertyName];


				this.itemsInfo = _.cloneDeep(this.cssListSettings[this.propertyName]);

				if (this.propertyName === 'fontFamily') {

					const assets = Asset.getVersionAssets(Version.SelectedVersion);

					this.itemsInfo.items = Object.keys(assets)
						.filter(id => assets[id].type === 'web-font')
						.map(id => ({name: assets[id].codename, value: assets[id].codename}))
						.concat(this.standardFonts.map(fontName => ({name: fontName, value: fontName})))
						.concat([{name: 'initial', value: 'initial'}, {name: 'inherit', value: 'inherit'}]);

				}

				let item = this.itemsInfo.items.find(item => item.value === this.value || Array.isArray(item.synonyms) && item.synonyms.indexOf(this.value) >= 0);

				if (!item) {

					const defaultId = this.itemsInfo.default;

					item = this.itemsInfo.items[defaultId];

					console.warn(`Setting "${this.settingName}" has invalid value: "${this.value}" in "${this.propertyName}" property. Fallback to default value: "${item.value}"`);

					this.selectItem(item.value, item.name);

				}

				this.itemName = item.name;

			},
			isActiveItem(value, itemName) {

				return this.itemName === itemName;

			},
			selectItem(value, itemName) {

				Broadcast.call("Pseudo Modal Hide", [this._uid + 'css-list-control-dropdown']);

				this.itemName = itemName;

				this.value = value;

				Settings.setCSSSettingValue(this.settingName, this.propertyName, value);

			}
		}
	}
</script>

<style lang="sass">

	.css-list-active-title
		border-bottom-right-radius: 0 !important
		background-color: #20a8d8 !important
		transition: 0.2s !important

		&:hover
			background-color: #1b8eb7 !important

	.css-list-control
		position: relative
		font-size: .65rem
		line-height: 20px

		.css-list-title
			font-size: 0.76563rem
			cursor: pointer
			border-radius: 0 0.2rem 0.2rem 0
			margin-top: 2px
			border: 1px solid #23282c
			background-color: #515b65
			background-clip: padding-box
			height: calc(1.5em + 0.5rem + 3px)
			color: #e4e7ea
			width: 200px
			outline: none
			padding: 0.25rem 0.5rem 0.25rem 0.5rem
			user-select: none

			&::placeholder
				color: rgba(255, 255, 255, 0.1)

		.css-list-menu
			z-index: 10000
			background-color: #20a8d8
			border-left: 1px solid #23282c
			border-right: 1px solid #23282c
			position: absolute
			width: 200px
			box-shadow: 0 3px 3px 0 rgba(33, 33, 33, 0.5)

			.css-list-item
				padding: 0.25rem 0.5rem
				font-size: 0.76563rem
				border-bottom: 1px solid #23282c
				cursor: pointer
				transition: 0.2s

				&:hover
					background-color: #1b8eb7



</style>
